import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config } from '@/pageConfig/fsd/us/en';
import { FSDPageTemplate } from '@/pageTemplate/FSDPageTemplate';
import { NextPageContext } from 'next';
import { useEffect } from 'react';

export default function FSDPage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();

  useEffect(() => trackEventWithGeolocation('fsd_page.viewed', {}), [trackEventWithGeolocation]); // biome-ignore lint/correctness/useExhaustiveDependencies: we just want it on load so no need to add it as a dependency

  return <FSDPageTemplate config={config} />;
}

FSDPage.getInitialProps = async (ctx: NextPageContext): Promise<{ readonly hideCookieConsent: boolean }> => {
  return {
    hideCookieConsent: true,
  };
};
